export const PATHS = {
  // Public Routes
  login: "/login",
  unauthorized: "/unauthorized",
  acceptInvitation: "/accept-invitation",
  forgotPassword: "/forgot-password",
  resetPassword: "/reset-password",

  // Protected Routes
  dashboard: "/",
  settings: "/settings",

  // Approvals
  approvals: "/approvals",

  // User Management
  users: {
    root: "/users",
    detail: "/users/:userId",
  },

  // Account Management
  accounts: {
    root: "/accounts",
    detail: "/accounts/:accountId",
  },

  // Transactions
  transactions: "/transactions",

  // KYC & Compliance
  compliance: {
    root: "/compliance",
    kycDetail: "/compliance/kyc/:kycId",
    kybDetail: "/compliance/kyb/:kybId",
  },

  // Business KYB (Legacy)
  businessKyb: "/business",

  // Products
  products: {
    root: "/products",
    details: "/product-details/:productId",
    planDetails: "/product-details/:productId/:subAccountId",
    fixedDeposit: "/fixed-deposit",
    personalLoan: "/personal-loan",
    roboCircle: "/robocircle",
    roboCollect: "/robocollect",
    roboMass: "/robomass",
    roboSaveBusiness: "/robosave-business",
    smartPay: "/smartpay",
  },

  // Loans
  loans: "/loans",
  loanDetail: "/loans/:loanType/:loanId",

  // Analytics
  analytics: "/analytics",

  // Support
  support: "/support",

  // Notifications
  notifications: "/notifications",

  // AI Hub
  ai: "/ai",

  // Agents
  agents: "/agents",

  // Security
  security: "/security",
};

export const LOGOPATH = "/robobank-logo.png";
